module.exports = __webpack_public_path__ + "img/weixin.234cd606.png";